module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[117]482.b7ccdc7.woff2";